export default __webpack_public_path__ + "img/img03.f603d3b6.png";